// Tarjetas del carrusel 3D del panel derecho (versión "El ecosistema que no
// duerme"). Valores de muestra tomados del handoff de diseño — la
// distribución de automatizaciones por módulo es placeholder, pendiente de
// confirmar con negocio antes de reemplazarla por datos reales de la API.
export const ecosystemModules = [
  { category: "AMBIENTAL", title: "Energía", subtitle: "kWh → tCO₂e automático", accent: "#C3E2F7" },
  { category: "AMBIENTAL", title: "Agua", subtitle: "Consumo e intensidad", accent: "#C3E2F7" },
  { category: "AMBIENTAL", title: "Efluentes", subtitle: "Parámetros y límites", accent: "#C3E2F7" },
  { category: "AMBIENTAL", title: "GEI", subtitle: "Alcances 1, 2 y 3", accent: "#C3E2F7" },
  { category: "AMBIENTAL", title: "Residuos", subtitle: "% reciclado y desviado", accent: "#C3E2F7" },
  { category: "SEGURIDAD", title: "Plan Anual", subtitle: "Avance en vivo", accent: "#578EBF" },
  { category: "SEGURIDAD", title: "Matriz Legal", subtitle: "Alertas de vencimiento", accent: "#578EBF" },
  { category: "SEGURIDAD", title: "Accidentes", subtitle: "Causa raíz digital", accent: "#578EBF" },
  { category: "SEGURIDAD", title: "Permisos", subtitle: "Aprobaciones digitales", accent: "#578EBF" },
  { category: "SOCIAL", title: "Debida Diligencia", subtitle: "Proceso completo", accent: "#FFFFFF" },
  { category: "SOCIAL", title: "Riesgos Sociales", subtitle: "Matriz de riesgo", accent: "#FFFFFF" },
  { category: "SOCIAL", title: "Políticas", subtitle: "Gestor y brechas", accent: "#FFFFFF" },
];

// KPIs del panel derecho de escritorio (versión carrusel).
export const ecosystemKpis = [
  { dot: "#C3E2F7", label: "CUMPLIMIENTO LEGAL", value: "87%" },
  { dot: "#578EBF", label: "GEI · EMISIONES", value: "1.240", unit: "tCO₂e" },
  { dot: "#FFFFFF", label: "PLAN ANUAL", value: "68%" },
];
